import { render } from "./companyIntr.vue?vue&type=template&id=3ad3e588&scoped=true"
import script from "./companyIntr.vue?vue&type=script&lang=js"
export * from "./companyIntr.vue?vue&type=script&lang=js"

import "./companyIntr.vue?vue&type=style&index=0&id=3ad3e588&scoped=true&lang=css"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad3e588"]])

export default __exports__